import { SidebarMenuItem } from 'app/domains/common-ui';
import { useLinkMatch } from '../useLinkMatch';
export function ItemLink(props) {
    const { to, icon, label, matchPath, matchExact = false, adornmentRight } = props;
    const active = useLinkMatch({ matchPath, matchExact });
    return <SidebarMenuItem to={to} icon={icon} label={label} active={active} adornmentRight={adornmentRight}/>;
}
